export const redirectToRoute = (route, paramId) => {
  let faceliftRoute

  switch (route) {
    case '/cotacoes':
      faceliftRoute = `${process.env.REACT_APP_URL_MAIN}/Marketplacecliente/cotacoes`
      break
    case `/cotacoes/${paramId.idCotacao}`:
      faceliftRoute = `${process.env.REACT_APP_URL_MAIN}/MarketPlaceCliente/MinhaCotacao?id=${paramId.idCotacao}`
      break
    case '/negociacoes':
      faceliftRoute = `${process.env.REACT_APP_URL_MAIN}/Marketplacecliente/negociacoes`
      break
    case `/negociacoes/${paramId.idNegociacao}`:
      faceliftRoute = `${process.env.REACT_APP_URL_MAIN}/MarketPlaceCliente/MinhaNegociacao?id=${paramId.idNegociacao}`
      break
    case '/meus-pedidos':
      faceliftRoute = `${process.env.REACT_APP_URL_MAIN}/pedidos/lista`
      break
    case `/meus-pedidos/${paramId.idPedido}`:
      faceliftRoute = `${process.env.REACT_APP_URL_MAIN}/MarketPlaceCliente/MeuPedido?id=${paramId.idPedido}`
      break
    case '/gimplus':
      faceliftRoute = `${process.env.REACT_APP_URL_MAIN}/Marketplacecliente/gimplus`
      break
    case '/':
      faceliftRoute = `${process.env.REACT_APP_URL_MAIN}/Marketplacecliente/meuperfil`
      break
    case '/meu-perfil':
      faceliftRoute = `${process.env.REACT_APP_URL_MAIN}/Marketplacecliente/meuperfil`
      break
    default:
      faceliftRoute = `${process.env.REACT_APP_URL_MAIN}/Marketplacecliente/meuperfil`

      break
  }

  return faceliftRoute
}
